const formatDate = (d?: Date, dateOnly?: boolean | undefined, hourOnly?: boolean | undefined, country?: string | undefined) => {
    if (!d) return;

    d = new Date(d);
    let options: Intl.DateTimeFormatOptions = { timeZone: 'Asia/Jerusalem' };
    if (dateOnly) options = { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'Asia/Jerusalem' };
    else if (hourOnly) options = { hour: 'numeric', minute: 'numeric', timeZone: 'Asia/Jerusalem' };
    else
        options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            timeZone: 'Asia/Jerusalem',
        };

    let str;
    if (country) {
        str = d.toLocaleDateString(country, options);
    } else {
        str = d.toLocaleDateString('en-GB', options);
    }
    if (hourOnly) return str.split(',')[1];
    else return str;
};

const formatDateAndTimeTextually = (d: Date) => {
    const dateText = formatDateTextOnly(d);
    const str: string = formatDate(d, false, false) || '';
    const dateOnly: string = formatDate(d, true) || '';

    return str.replace(dateOnly, dateText);
};

const formatDateByTimePassed = (time: Date) => {
    const then = new Date(time);
    const now = new Date();

    const msBetweenDates = Math.abs(then.getTime() - now.getTime());
    const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);

    if (hoursBetweenDates < 24) {
        return then.toLocaleTimeString('he-IL', {
            hour: '2-digit',
            minute: '2-digit',
        });
    } else if (hoursBetweenDates < 24 * 7) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[then.getDay()];
    } else {
        return then.toLocaleDateString();
    }
};

const formatDateTextOnly = (d: Date) => {
    // Validate date
    if (!d || isNaN(new Date(d).getTime())) {
        return '';
    }

    const dateOnly: string = formatDate(d, true) || '';

    const today: string = formatDate(new Date(), true) || '';
    const yesterday: string = formatDate(new Date(new Date().setDate(new Date().getDate() - 1)), true) || '';
    const dayBeforeYesterday: string = formatDate(new Date(new Date().setDate(new Date().getDate() - 2)), true) || '';
    const tomorrow: string = formatDate(new Date(new Date().setDate(new Date().getDate() + 1)), true) || '';
    const dayAfterTomorrow: string = formatDate(new Date(new Date().setDate(new Date().getDate() + 2)), true) || '';

    if (dateOnly === today) {
        return 'היום';
    } else if (dateOnly === yesterday) {
        return 'אתמול';
    } else if (dateOnly === dayBeforeYesterday) {
        return 'שלשום';
    } else if (dateOnly === tomorrow) {
        return 'מחר';
    } else if (dateOnly === dayAfterTomorrow) {
        return 'מחרתיים';
    } else {
        // Check if date is within the last week
        const now = new Date();
        const daysDifference = Math.floor((now.getTime() - new Date(d).getTime()) / (1000 * 60 * 60 * 24));

        if (daysDifference >= 2 && daysDifference < 7) {
            const hebrewDays = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
            const dayName = hebrewDays[new Date(d).getDay()];
            return `יום ${dayName}`;
        }

        return dateOnly;
    }
};

/** Format date as YYYY-MM-DD (date only, no time). */
export const toDateOnlyString = (d: Date): string => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

/** Normalize date to local start-of-day (00:00:00.000). */
export const startOfDay = (d: Date): Date => {
    const copy = new Date(d);
    copy.setHours(0, 0, 0, 0);
    return copy;
};

/** Parse date string to Date. YYYY-MM-DD → local midnight; ISO strings passed through. */
export const parseDateOnly = (s: string): Date => {
    if (!s || typeof s !== 'string') return new Date(NaN);
    if (s.includes('T')) return new Date(s);
    return new Date(s + 'T00:00:00');
};

export { formatDate, formatDateByTimePassed, formatDateAndTimeTextually, formatDateTextOnly };
